import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import useApi from '../hooks/useApi';
import { endpoints } from '../utils/utils';
import Autocomplete from 'react-google-autocomplete';
import { useLoadScript } from '@react-google-maps/api';
import UserService from '../services/user.service';
import { useTranslation } from 'react-i18next';


const libraries = ['places'];

const EditAdresse = () => {
  const [formData, setFormData] = useState({
    primary_address_id: '',
    street: '',
    zip_code: '',
    city: '',
    street_number: '',
    state: '',
    state_code: '',
    country: 'Switzerland',
    country_code: 'CH',
    lat: null,
    lng: null,
  });

  const [user, setUser] = useState(null);

  const api = useApi();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('editadresse');
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  useEffect(() => {
    const fetchAddress = async () => {
      try {
        const response = await api.get(endpoints.getProfil);
        setUser(response.data.user);
        // Only prefill the form if the navigation requested it via location.state.prefill
        const loc = location?.state || {};
        if (loc.prefill) {
          setFormData({
            primary_address_id: response.data.user?.primary_address?.id || '',
            street: response.data.user?.primary_address?.street || '',
            zip_code: response.data.user?.primary_address?.zip_code || '',
            state: response.data.user?.primary_address?.state || '',
            state_code: response.data.user?.primary_address?.state_code || '',
            city: response.data.user?.primary_address?.city || '',
            country: response.data.user?.primary_address?.country || '',
            country_code: response.data.user?.primary_address?.country_code || '',
            lat: response.data.user?.primary_address?.latitude || '',
            lng: response.data.user?.primary_address?.longitude || '',
          });
        }
      } catch (err) {
        console.error('Erreur lors de la récupération de l\'adresse :', err);
      }
    };

    fetchAddress();
  }, []);

  const handlePlaceSelect = (place) => {
    const addressComponents = place.address_components;
    const newAddress = {
      street: '',
      city: '',
      zip_code: '',
      street_number: '',
      state: '',
      state_code: '',
      country: 'Switzerland',
      country_code: 'CH',
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };
    console.log("places", addressComponents)
    for (const component of addressComponents) {
      const componentType = component.types[0];
      switch (componentType) {
        case 'street_number':
          newAddress.street_number = `${component.long_name}`;
          break;
        case 'route':
          newAddress.street = `${component.long_name}`;
          break;
        case 'locality':
          newAddress.city = component.long_name;
          break;
        case 'postal_code':
          newAddress.zip_code = component.long_name;
          break;
        case 'administrative_area_level_1':
          newAddress.state = component.long_name;
          newAddress.state_code = component.short_name;
          break;
        case 'country':
          newAddress.country = component.long_name;
          newAddress.country_code = component.short_name;
          break;
        /* case 'street_number':
          newAddress.street_number = component.long_name;
          break; */
        default:
          break;
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      ...newAddress,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await UserService.update(user?.id, formData, api);
      navigate('/profile');
    } catch (err) {
      console.error('Erreur lors de la mise à jour de l\'adresse :', err);
    }
  };

  if (loadError) return <div>Erreur de chargement des cartes</div>;
  if (!isLoaded) return <div>Chargement des cartes...</div>;

  return (
    <>
      <Header />

      <div className="container container-profile">
        <div className="name">{t('title')}</div>
        <form className="form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('address')}</label>
            <Autocomplete
              apiKey="YOUR_GOOGLE_MAPS_API_KEY"
              onPlaceSelected={handlePlaceSelect}
              options={{ types: ['address'], componentRestrictions: { country: 'CH' } }}
              placeholder={t('addressPlaceholder')}
              style={{ width: '100%', padding: '0 15px', height: '40px' }}
            />
          </div>
          <div className="form-group">
            <label>{t('street')}</label>
            <input
              type="text"
              name="street"
              value={formData.street}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>{t('zip')}</label>
            <input
              type="text"
              name="zip_code"
              value={formData.zip_code}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>{t('city')}</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-submit">
            <input type="submit" value={t('submit')} />
          </div>
        </form>
      </div>

    </>
  );
};

export default EditAdresse;
